"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var _jsxRuntime = require("react/jsx-runtime");
var _material = require("@mui/material");
var _react = require("react");
var _ExpandMore = _interopRequireDefault(require("@mui/icons-material/ExpandMore"));
var _ExpandLess = _interopRequireDefault(require("@mui/icons-material/ExpandLess"));
var _util = require("./util");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function SideMenu(_a) {
  var toggle = _a.toggle,
    pathname = _a.pathname,
    links = _a.links,
    logo = _a.logo,
    logoDescription = _a.logoDescription,
    backgroundColor = _a.backgroundColor,
    textColor = _a.textColor,
    _b = _a.accentColor,
    accentColor = _b === void 0 ? null : _b,
    _c = _a.logoutUser,
    logoutUser = _c === void 0 ? null : _c;
  var _d = (0, _react.useState)(null),
    linkMenuanchorEl = _d[0],
    setLinkMenuAnchorEl = _d[1];
  var _e = (0, _react.useState)(null),
    selectedLink = _e[0],
    setSelectedLink = _e[1];
  var handleLinkMenuClick = function handleLinkMenuClick(event, link) {
    setLinkMenuAnchorEl(event.currentTarget);
    setSelectedLink(link);
  };
  var handleLinkMenuClose = function handleLinkMenuClose() {
    setLinkMenuAnchorEl(null);
    setSelectedLink(null);
  };
  return (0, _jsxRuntime.jsx)("div", __assign({
    role: "presentation",
    onKeyDown: toggle,
    style: {
      width: '250px',
      height: '100%',
      backgroundColor: backgroundColor
    }
  }, {
    children: (0, _jsxRuntime.jsxs)(_material.List, {
      children: [(0, _jsxRuntime.jsx)("div", __assign({
        style: {
          width: '100%',
          display: 'flex',
          justifyContent: 'center'
        }
      }, {
        children: (0, _jsxRuntime.jsx)("img", {
          width: 150,
          height: 150,
          style: {
            objectFit: 'contain'
          },
          src: logo,
          alt: logoDescription,
          title: logoDescription
        })
      })), (0, _jsxRuntime.jsx)(_material.Divider, {}), links.map(function (link, index) {
        return link == null ? (0, _jsxRuntime.jsx)(_material.Divider, {}, index) : (0, _jsxRuntime.jsxs)("div", {
          children: [(0, _jsxRuntime.jsxs)(_material.ListItem
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore THIS PROPS IS DEPRECATED
          , __assign({
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore THIS PROPS IS DEPRECATED
            button: true,
            component: "a",
            href: link.subLinks ? null : link.slug,
            "aria-haspopup": link.subLinks ? 'true' : 'false',
            onClick: link.subLinks ? function (e) {
              return handleLinkMenuClick(e, link);
            } : toggle,
            style: {
              marginRight: '40px',
              color: !accentColor || (0, _util.isSelected)(pathname, link.slug) ? textColor : accentColor,
              textDecoration: !accentColor && (0, _util.isSelected)(pathname, link.slug) ? 'underline' : undefined,
              textUnderlineOffset: '3px'
            }
          }, {
            children: [(0, _jsxRuntime.jsx)(_material.ListItemText, {
              primary: link.text
            }), link.subLinks && (linkMenuanchorEl && (selectedLink === null || selectedLink === void 0 ? void 0 : selectedLink.slug) === link.slug ? (0, _jsxRuntime.jsx)(_ExpandLess.default, {}) : (0, _jsxRuntime.jsx)(_ExpandMore.default, {}))]
          })), (selectedLink === null || selectedLink === void 0 ? void 0 : selectedLink.subLinks) && (0, _jsxRuntime.jsx)(_material.Menu, __assign({
            id: "simple-menu",
            anchorEl: linkMenuanchorEl,
            keepMounted: true,
            open: Boolean(linkMenuanchorEl),
            onClose: handleLinkMenuClose,
            elevation: 0,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'center'
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'center'
            }
          }, {
            children: selectedLink === null || selectedLink === void 0 ? void 0 : selectedLink.subLinks.map(function (subLink, subLinkIndex) {
              return (0, _jsxRuntime.jsx)(_material.MenuItem, __assign({
                component: "a",
                onClick: handleLinkMenuClose,
                href: (selectedLink === null || selectedLink === void 0 ? void 0 : selectedLink.slug) + subLink.slug,
                style: {
                  fontSize: '14px'
                }
              }, {
                children: subLink.text
              }), subLinkIndex);
            })
          }))]
        }, index);
      }), logoutUser != null && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [(0, _jsxRuntime.jsx)(_material.Divider, {}), (0, _jsxRuntime.jsx)(_material.ListItem, __assign({
          button: true,
          component: "button",
          onClick: logoutUser,
          style: {
            marginRight: '40px',
            color: textColor
          }
        }, {
          children: (0, _jsxRuntime.jsx)(_material.ListItemText, {
            primary: "Logout"
          })
        }))]
      }), (0, _jsxRuntime.jsx)(_material.Divider, {})]
    })
  }));
}
var _default = SideMenu;
exports.default = _default;